<template>
  <div id="app" class="app-content mb-4">
    <!-- <div>
      <h2>Roshan Two</h2>
      <p>{{ profile }}</p>
    </div> -->
    <div class="container" v-if="profile.author">
      <div class="row mb-5">
        <div class="col-12">
          <div class="amej-title"></div>
        </div>
      </div>
      
      <div class="home-card-deck">
        <b-card class="user-info-card">
          <b-card-body>
            <b-card-title class="dark-variant">Hi, {{profile.author.full_name}} !</b-card-title>
            <div class="user-info">
              <b-card-text>
                <div class="user-name">
                  <p>User:</p>
                  <span>{{profile.author.full_name}}</span>
                </div>
                <div class="user-name">
                  <p>Email:</p>
                  <span>{{profile.author.email}}</span>
                </div>
                <div class="user-country">
                  <p>Country:</p>
                  <div class="span">
                    <span v-if="profile.author && profile.author.country">{{profile.author.country}}</span>
                    <span v-else>N/a</span>
                    <span v-if="currentLocation" class="ip-tracing">
                      <em>Online from: </em>
                      <span v-if="currentLocation.city">{{ currentLocation.city }},</span>
                      <span v-if="currentLocation.country">{{ currentLocation.country }}</span>
                      <span v-if="currentLocation.country">
                        <span v-if="currentLocation.country.flag">
                          &nbsp;
                          <img :src="currentLocation.country.flag" width="18" height alt />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
              </b-card-text>
            </div>
          </b-card-body>
        </b-card>

        <b-card class="balance-info-card">
          <b-card-body>
            <b-card-title class="dark-variant balance-title">
              <span>Main Balance</span>
              <CurrencySelector
                v-model="displayCurrency"
                compact
                @change="onCurrencyChange"
              />
            </b-card-title>
            <div class="balance-info">
              <b-card-text class="dark-variant">
                <p>Available Balance :</p>
                <p v-if="showsEquivalent">In {{ displayCurrency }} :</p>
                <p>Amej Coin :</p>
                <p>{{ showsEquivalent ? "Today's Rate" : 'Equivalent Balance' }}</p>
              </b-card-text>
              <b-card-text class="dark-variant">
                <p>US$ {{ formatBalance(profile.coins) }}</p>

                <!-- Display conversion at the mid rate. A real conversion is priced by
                     the server, with the markup applied at confirmation. -->
                <p v-if="showsEquivalent" class="balance-equivalent">
                  {{ equivalentBalance }}
                </p>

                <p>
                  {{ formatMoney(coinsToBalance(profile.coins) * (profile.rate ? profile.rate.buy : 0)) }}
                  <span class="coin">Coin</span>
                </p>
                <p v-if="showsEquivalent" class="balance-rate">1 USD = {{ rateText }}</p>
                <p v-else>$ 1 = 100 Coin</p>
                <div class="blank"></div>
              </b-card-text>
            </div>
            <small class="balance-note" v-if="showsEquivalent">
              Indicative rate for display. Conversions are priced at confirmation.
            </small>
          </b-card-body>
        </b-card>

        <!-- Bank & Interest removed (interest is not live yet). KYC status is what a
             user actually needs at a glance: it gates limits, payouts and withdrawals. -->
        <b-card class="kyc-basic-card">
          <b-card-body>
            <b-card-title class="dark-variant">
              <span>KYC</span>
              <span class="kyc-pill" :class="kycPillClass">{{ kycStatusText }}</span>
            </b-card-title>
            <div class="kyc-basic dark-variant">
              <div class="kyc-row">
                <p>Full Name :</p>
                <p>{{ kycFullName || '-' }}</p>
              </div>
              <div class="kyc-row">
                <p>Document :</p>
                <p>{{ kycDocumentText || '-' }}</p>
              </div>
              <div class="kyc-row">
                <p>Country :</p>
                <p>{{ kycCountry || '-' }}</p>
              </div>
              <div class="kyc-row" v-if="kycTierText">
                <p>Tier :</p>
                <p>{{ kycTierText }}</p>
              </div>
              <div class="kyc-action">
                <router-link :to="{ name: 'Kyc' }">
                  <span v-if="isKycVerified">View KYC details</span>
                  <span v-else-if="kycSubmitted">Check verification status</span>
                  <span v-else>Verify your identity</span>
                  <i class="material-icons">arrow_right_alt</i>
                </router-link>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>

      <div class="row">
        <div class="col-4 mt-5 dashboard-shortcuts">
          <router-link :to="{name: 'loadcard'}">
            <i class="material-icons">save_alt</i>
            <span>Load</span>
          </router-link>
        </div>
        <div class="col-4 mt-5 dashboard-shortcuts">
          <router-link :to="{name: 'pay'}">
            <i class="material-icons">payment</i>
            <span>Pay</span>
          </router-link>
        </div>
        <div class="col-4 mt-5 dashboard-shortcuts">
          <router-link :to="{name: 'request'}">
            <i class="material-icons">monetization_on</i>
            <span>Request</span>
          </router-link>
        </div>
        <div class="col-4 mt-5 dashboard-shortcuts">
          <router-link :to="{name: 'Mpin'}">
            <i class="material-icons">lock</i>
            <span>MPIN</span>
          </router-link>
        </div>
        <div class="col-4 mt-5 dashboard-shortcuts">
          <router-link :to="{name: 'withdraw'}">
            <i class="material-icons">account_balance</i>
            <span>Withdraw</span>
          </router-link>
        </div>
        <div class="col-4 mt-5 dashboard-shortcuts">
          <router-link :to="{name: 'profile'}">
            <i class="material-icons">perm_identity</i>
            <span>Profile</span>
          </router-link>
        </div>
      </div>

      <div class="row" v-if="showKycPrompt">
        <div class="col-12">
          <div class="kyc-prompt" :class="kycSubmitted ? 'is-pending' : ''">
            <div class="kyc-prompt-text">
              <strong>{{ kycPrompt.title }}</strong>
              <span>{{ kycPrompt.text }}</span>
            </div>
            <router-link :to="{ name: 'Kyc' }">
              <b-button variant="primary">{{ kycPrompt.action }}</b-button>
            </router-link>
          </div>
        </div>
      </div>

      <div class="row mt-5 transaction-statement">
        <div class="col-12 amej-title text-center pb-3">Latest Transactions</div>

        <div class="col-12" v-if="latestTransactions.length">
          <div class="txn-list">
          <div class="txn-item" v-for="(txn, index) in latestTransactions" :key="'lt' + index">
            <img class="txn-avatar" :src="avatarOf(txn)" :alt="partyNameOf(txn)" @error="onAvatarError" />
            <div class="txn-body">
              <div class="txn-top">
                <span class="txn-title">{{ txn.title || 'Transaction' }}</span>
                <span class="txn-amount" :class="isCredit(txn) ? 'is-in' : 'is-out'">
                  {{ isCredit(txn) ? '+' : '-' }} $ {{ formatMoney(txn.amount) }}
                </span>
              </div>
              <div class="txn-party">{{ partyNameOf(txn) || '-' }}</div>
              <div class="txn-remarks" v-if="cleanText(txn.remarks)">{{ cleanText(txn.remarks) }}</div>
              <div class="txn-meta">
                <span class="txn-pill" :class="isCredit(txn) ? 'is-in' : 'is-out'">
                  {{ isCredit(txn) ? 'Received' : 'Sent' }}
                </span>
                <span class="txn-date">{{ txn.date | formatDate }}</span>
              </div>
            </div>
          </div>
          </div>
        </div>

        <div class="col-12" v-else>
          <p class="text-center text-muted">No transactions yet.</p>
        </div>

        <div class="col-12 text-center pt-2 see-more" v-if="latestTransactions.length">
          <router-link :to="{ name: 'transactions' }">
            See more transactions
            <i class="material-icons">chevron_right</i>
          </router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatBalance, formatMoney, coinsToBalance, cleanText, cleanName } from "@/utils/format";
import fallbackAvatar from "@/assets/profile.svg";
import CurrencySelector from "../reuseable_components/CurrencySelector.vue";
import {
  convert, formatCurrency, formatRate, findRate, getDisplayCurrency, setDisplayCurrency, hasDisplayCurrency, BASE_CURRENCY,
} from "@/utils/currency";

export default {
  name: "Content",
  components: { CurrencySelector },
  computed: {
    /** Prompt only when the profile explicitly says KYC is not verified. */
    showKycPrompt: function () {
      const a = this.profile && this.profile.author;
      if (!a) { return false; }
      return a.is_kyc_verified === false;
    },
    /** Already sent in? Then it is awaiting review, not awaiting the user. */
    kycSubmitted: function () {
      const k = this.userKyc || {};
      if (k.submitted === true) { return true; }
      const status = String(k.status || (this.profile && this.profile.author && this.profile.author.kyc_status) || "");
      return status !== "" && status !== "not_submitted";
    },
    kycPrompt: function () {
      if (this.kycSubmitted) {
        return {
          title: "KYC under review",
          text: "Your KYC has been submitted and is being reviewed. Your limits stay restricted until it is approved.",
          action: "Check KYC",
        };
      }
      return {
        title: "Verify your identity",
        text: "Your account is not KYC verified, so your transaction and withdrawal limits are restricted. Complete your KYC to unlock higher limits.",
        action: "Submit KYC",
      };
    },
    /** Newest first, capped at 5 so the dashboard stays light. */
    latestTransactions: function () {
      const list = Array.isArray(this.transactions)
        ? this.transactions
        : (this.transactions && Array.isArray(this.transactions.results) ? this.transactions.results : []);
      return list.slice().sort(function (a, b) {
        return new Date(b.date || 0) - new Date(a.date || 0);
      }).slice(0, 10);
    },
    ...mapState([
      "userKyc","profile", "transactions", "token", "userBanks", "currencies"]),

    /* ---------------- KYC basic info (replaces Bank & Interest) ---------------- */
    kyc: function () { return this.userKyc || {}; },
    isKycVerified: function () {
      const author = (this.profile && this.profile.author) || {};
      return this.kyc.is_verified === true ||
             this.kyc.is_kyc_verified === true ||
             author.is_kyc_verified === true;
    },
    kycSubmitted: function () {
      const author = (this.profile && this.profile.author) || {};
      return this.kyc.submitted === true ||
             Boolean(this.kyc.status && this.kyc.status !== 'not_submitted') ||
             Boolean(author.kyc_status && author.kyc_status !== 'not_submitted');
    },
    kycStatusText: function () {
      const author = (this.profile && this.profile.author) || {};
      const raw = String(this.kyc.status || author.kyc_status || 'not_submitted');
      const map = {
        verified: 'Verified', pending: 'Pending', rejected: 'Rejected',
        not_submitted: 'Not submitted', submitted: 'Pending',
      };
      return map[raw] || raw.replace(/_/g, ' ');
    },
    kycPillClass: function () {
      if (this.isKycVerified) { return 'is-verified'; }
      if (this.kycSubmitted) { return 'is-pending'; }
      return 'is-none';
    },
    kycFullName: function () {
      const author = (this.profile && this.profile.author) || {};
      const fromKyc = [this.kyc.first_name, this.kyc.middle_name, this.kyc.last_name]
        .filter(Boolean).join(' ');
      return cleanText(fromKyc || this.kyc.full_name || author.full_name || '');
    },
    kycDocumentText: function () {
      const d = this.kyc.document_type;
      const label = (d && (d.name || d.title || d.code)) || this.kyc.document_type_name || '';
      const number = this.kyc.document_number || '';
      if (label && number) { return label + ' \u00b7 ' + number; }
      return label || number || '';
    },
    kycCountry: function () {
      const author = (this.profile && this.profile.author) || {};
      return cleanText(this.kyc.country || author.country || '');
    },
    kycTierText: function () {
      const t = this.kyc.tier || this.kyc.level;
      return t ? ('Tier ' + t) : '';
    },

    /** Only worth showing when the view currency differs from the wallet's USD. */
    showsEquivalent: function () {
      return this.displayCurrency &&
             this.displayCurrency !== BASE_CURRENCY &&
             Boolean(findRate(this.currencies, this.displayCurrency));
    },
    equivalentBalance: function () {
      const usd = coinsToBalance(this.profile && this.profile.coins);
      const value = convert(this.currencies, usd, BASE_CURRENCY, this.displayCurrency);
      if (value === null) { return ""; }
      return formatCurrency(this.currencies, value, this.displayCurrency);
    },
    rateText: function () {
      const row = findRate(this.currencies, this.displayCurrency);
      if (!row) { return ""; }
      const r = (row.buy !== undefined && row.buy !== null) ? row.buy : row.rate;
      // formatRate, not formatCurrency: a JPY rate rendered with the currency's own
      // zero decimals reads "1 USD = 159" and throws away real precision.
      return formatRate(this.currencies, r, this.displayCurrency);
    },
    mainbankDetail: function(){
      let allUserBanks = this.userBanks
      let singleBank = null
      if(allUserBanks && allUserBanks.length > 0 ){
        singleBank = allUserBanks.find(x => x.bank_type === "Primary")
        if(!singleBank){
          singleBank = allUserBanks[0]
        }
      }
      return singleBank
    },
  },
  data() {
    return {
      // What the person is viewing in. Remembered per browser; falls back to the
      // account's default_currency the first time the profile loads.
      displayCurrency: getDisplayCurrency(BASE_CURRENCY),
      GEO_API_KEY: "at_meCxrHHg1mhiu3WH5msDAEXNmYrRE",
      currentLocation: null, // Initialize as null, not from localStorage
    };
  },
  created() {
    this.getUserKyc();
    this.listProfile();
    this.listCurrencies();
    this.listTransactions();
    this.listUserBanks();
    // Try to load from cache first
    this.loadCachedLocation();
  },
  mounted: function () {
    // `state.token` is null (not "") when the key is absent, so this comparison never
    // fired. The router guard in main.js now owns this, and sends the user to /login
    // with where they were going - not to the marketing home page.

    // console.log("This Page Content");
    this.fetchUserLocation();
  },
  watch: {
    profile: function () {
      const author = (this.profile && this.profile.author) || {};
      if (!hasDisplayCurrency() && author.default_currency) {
        this.displayCurrency = author.default_currency;
      }
    },
  },
  methods: {
    formatMoney: formatMoney,
    cleanText: cleanText,
    /** A withdraw/debit shows the recipient; a credit shows who sent it. */
    isCredit(txn) {
      const d = String(txn && txn.direction || "").toLowerCase();
      if (d) { return d === "credit" || d === "incoming"; }
      return false;
    },
    partyOf(txn) {
      if (!txn) { return {}; }
      return this.isCredit(txn) ? (txn.author || txn.from || {}) : (txn.to || txn.recipient || {});
    },
    partyNameOf(txn) {
      const p = this.partyOf(txn);
      return cleanName(p.full_name || p.email || "");
    },
    avatarOf(txn) {
      const p = this.partyOf(txn);
      return p.image || fallbackAvatar;
    },
    onAvatarError(e) {
      if (e && e.target && e.target.src !== fallbackAvatar) { e.target.src = fallbackAvatar; }
    },
    formatBalance: formatBalance,
    formatMoney: formatMoney,
    coinsToBalance: coinsToBalance,
    ...mapActions(["getUserKyc", "listProfile", "listTransactions", "listUserBanks", "listCurrencies"]),

    onCurrencyChange(code) {
      this.displayCurrency = code;
      setDisplayCurrency(code);
    },
    
    loadCachedLocation() {
      try {
        const cached = localStorage.getItem("currentLocation");
        if (cached) {
          this.currentLocation = JSON.parse(cached);
          // console.log("Loaded cached location:", this.currentLocation);
        }
      } catch (error) {
        console.error("Error parsing cached location:", error);
        localStorage.removeItem("currentLocation");
      }
    },

    fetchUserLocation() {
      fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
        .then(({ ip }) => {
          if (!ip) {
            console.error("No IP found");
            return;
          }

          console.log("✅ Fetched IP:", ip);
          localStorage.setItem("currentIPAddress", ip);

          // ALWAYS fetch geolocation (don't skip if IP matches)
          // const geoUrl = `https://geo.ipify.org/api/v2/country?apiKey=${this.GEO_API_KEY}&ipAddress=${ip}`;
          const geoUrl = `http://ip-api.com/json/${ip}?fields=status,message,continent,country,countryCode,region,regionName,city,zip,geotargeting,country_groupings,lat,lon,timezone,isp,org,as,query`;
          // console.log("🔄 Fetching geo location...");

          fetch(geoUrl)
            .then((response) => {
              if (!response.ok) throw new Error(`API Error: ${response.status}`);
              return response.json();
            })
            .then((data) => {
              // console.log("✅ Location data:", data);
              this.$set(this, 'currentLocation', data);
              localStorage.setItem("currentLocation", JSON.stringify(data));
            })
            .catch((error) => {
              console.error("❌ Geo fetch failed:", error);
              // Try to load cached version on error
              this.loadCachedLocation();
            });
        })
        .catch((error) => {
          console.error("❌ IP fetch failed:", error);
        });
    }
  },
};
</script>

<style scoped>
.kyc-basic-card .card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.kyc-pill {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 12px;
  text-transform: capitalize;
}
.kyc-pill.is-verified { background: #e7f6ed; color: #1e8c50; }
.kyc-pill.is-pending  { background: #fff5e0; color: #9a6b00; }
.kyc-pill.is-none     { background: #fdeaea; color: #c83c3c; }
.kyc-basic .kyc-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 10px;
}
.kyc-basic .kyc-row p { margin: 0; }
.kyc-basic .kyc-row p:last-child { font-weight: 600; text-align: right; }
.kyc-action { margin-top: 14px; }
.kyc-action a { display: inline-flex; align-items: center; font-size: 13px; }
.kyc-action .material-icons { font-size: 16px; margin-left: 4px; }
.balance-info-card .balance-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.balance-equivalent { font-weight: 600; color: #0066b3; }
.balance-rate { font-size: 13px; color: #6b7280; }
.balance-note { display: block; margin-top: 6px; font-size: 11px; color: #8a94a6; }
</style>
<style lang="scss" scoped>
  @import '../../css/style.scss';

.txn-item {
  display: flex; gap: 14px; align-items: flex-start;
  background: #fff; border: 1px solid rgba(0,0,0,0.07); border-radius: 10px;
  padding: 14px 16px; margin-bottom: 12px;
}
.txn-avatar {
  width: 46px; height: 46px; border-radius: 50%; object-fit: cover;
  background: #f1f3f5; flex: 0 0 auto;
}
.txn-body { flex: 1; min-width: 0; }
.txn-top { display: flex; justify-content: space-between; align-items: baseline; gap: 12px; }
.txn-title { font-weight: 600; font-size: 15px; color: #1b1b1b; }
.txn-amount { font-weight: 700; font-size: 15px; white-space: nowrap; }
.txn-amount.is-in { color: #00a800; }
.txn-amount.is-out { color: #1b1b1b; }
.txn-party { font-size: 13px; color: #55606a; margin-top: 2px; }
.txn-remarks {
  font-size: 12px; color: #8a949e; margin-top: 3px;
  overflow: hidden; text-overflow: ellipsis; display: -webkit-box;
  -webkit-line-clamp: 2; -webkit-box-orient: vertical;
}
.txn-meta { display: flex; align-items: center; gap: 10px; margin-top: 8px; }
.txn-pill { font-size: 10px; font-weight: 700; padding: 2px 9px; border-radius: 10px; }
.txn-pill.is-in { background: #e3f7e3; color: #00a800; }
.txn-pill.is-out { background: #eef1f4; color: #55606a; }
.txn-date { font-size: 11px; color: #9aa4ae; }
.text-muted { color: #6c757d; }

.kyc-prompt {
  display: flex; align-items: center; justify-content: space-between; gap: 16px;
  background: #fdf3e0; border: 1px solid #f2ddb4; border-radius: 10px;
  padding: 14px 18px; margin-top: 18px;
}
.kyc-prompt-text { display: flex; flex-direction: column; }
.kyc-prompt-text strong { color: #8a5a00; font-size: 15px; }
.kyc-prompt-text span { color: #8a5a00; font-size: 13px; }
@media (max-width: 575px) {
  .kyc-prompt { flex-direction: column; align-items: flex-start; }
}

.kyc-prompt.is-pending { background: #eef4fb; border-color: #cfe0f2; }
.kyc-prompt.is-pending .kyc-prompt-text strong,
.kyc-prompt.is-pending .kyc-prompt-text span { color: #14508c; }

/* Compact rows: 10 transactions now fit in the space 3 used to take. */
.transaction-statement .txn-item {
  padding: 9px 12px;
  margin-bottom: 7px;
  gap: 10px;
  align-items: center;
}
.transaction-statement .txn-avatar { width: 34px; height: 34px; }
.transaction-statement .txn-title { font-size: 13.5px; }
.transaction-statement .txn-amount { font-size: 14px; }
.transaction-statement .txn-party { font-size: 12px; margin-top: 0; }
.transaction-statement .txn-remarks {
  font-size: 11px; margin-top: 1px; -webkit-line-clamp: 1;
}
.transaction-statement .txn-meta { margin-top: 3px; gap: 8px; }
.transaction-statement .txn-pill { font-size: 9.5px; padding: 1px 7px; }
.transaction-statement .txn-date { font-size: 10.5px; }
/* Two columns on wide screens so the list stays short vertically. */
@media (min-width: 992px) {
  .transaction-statement .txn-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
  }
}
</style>
